<template>
  <div class="bullseye-diagram">
    <!-- {{availableSegments}} -->
    <ExternalSvg ref="svg" :width="_width" :height="_height">
      <!-- <filter id="shadow" x="0" y="0" width="200%" height="200%">
        <feOffset result="offOut" in="SourceAlpha" dx="0" dy="2" />
        <feColorMatrix result="matrixOut" in="offOut" type="matrix"
          values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0" />
        <feGaussianBlur result="blurOut" in="matrixOut" stdDeviation="5" />
        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
      </filter> -->
    </ExternalSvg>
    <div class="tooltip-container" ref="tooltipContainer" v-if="showTooltip"></div>
    <div class="marked-legend" v-if="markedSegments && markedSegments.length > 0"><span class="mark">—</span> {{$t('segments_with_values')}}</div>
  </div>
</template>

<script>
/*

USAGE:

  <BullseyeDiagram :data="data" :colorScale="'green'" :width="this.size.width" :height="this.size.height"></BullseyeDiagram> 

Props:
  data : Array of data like {id:xx, value:yy}
  colorScale: String (color) or function to define the color for each "value"

  datas : Array of Arrays like data
  colorScales: Array of colorScales (they will be matched by index with each of the arrays of datas)

  width, height : define the size (default: 300x300) (TODO: if not passed they should be measured instead of hardcoded...)

  v-model: Array of Objects (with an id property) of the currently selected segments. 
  selection: Same as v-model but without the two-way binding

  selectable: (default true)
  multiSelection: (default false)

  markedSegments: Array of segments to be "marked" as with values in the project (for filtering)

Quizas faltan props de "estilos" highlighted, selected etc... pero quizas se puede hacer todo con las classes que YA pone:
  '.selected', '.higlighted', '.unselected', '.unhiglighted'

*/
import ExternalSvg from '@/assets/svg/bullseye.svg?inline'
import d3 from '@/utils/d3importer'
import widgetContent from '@/mixins/widgetContent'

export default {
  name: 'BullseyeDiagram',
  mixins: [widgetContent],
  model:{
    prop: 'selection',
    event: 'change'
  },
  props: {
    data: Array,
    datas: {
      type: Array,
      validator: (v)=>{
        return Array.isArray(v[0]) || Array.isArray(v[0].data)
      }
    },
    colorScale: [String, Function], 
    colorScales: [Array],
    selection: {
      type: Array,
      default: ()=>[]
    },
    width: Number,
    height: Number,
    selectable:{
      type: Boolean,
      default: true
    },
    multiSelection: Boolean,
    instantUpdate: Boolean,
    showTooltip:{
      type: Boolean,
      default: false
    },
    availableSegments: null,
    markedSegments: {
      type: Array,
      default: ()=>[]
    }
  },
  components: {
    ExternalSvg
  },

  mounted () {
    this.update()
    
    d3.select(this.$refs.svg).on('click',()=>{
      if(d3.event.target.tagName === 'svg'){
        this.triggerChagne([])
      }
    })
  },
  methods:{
    triggerChagne (value) {
      this.$emit('change',value)
    },
    update(){
      let self = this
      // MUST FILL WITH EMPTIES
      let cellData = [...Array(32)].map((i,idx)=>({id:idx}))
      cellData.forEach((d,i)=>{
        let candidate = this._genericData.find((dd)=>String(dd.id) === String(d.id))
        if(candidate) cellData[i] = candidate
      })
      let cells = d3.select(this.$refs.svg).selectAll('.cell').data(cellData, function(d) { 
        return d && d.id || +d3.select(this).attr("id");
      })
      
      let updateClasses = () => {
        let currentSelection = self.selection || []
        
        if(self.availableSegments){
          let avialSegs = self.availableSegments || []
          cells.classed('disabled',(dd)=>{
            return !avialSegs.find((d)=>{
              return dd.id===d
            })
          })
        } else {
           cells.classed('disabled',false)
        }
        cells.classed('highlighted',(dd)=>dd===self.highlighted)
        cells.classed('unhighlighted',(dd)=>self.highlighted && dd!==self.highlighted)
        cells.classed('selected',(dd)=>currentSelection.find((d)=>d.id===dd.id))
        cells.classed('unselected',(dd)=>currentSelection.length>0 && !currentSelection.find((d)=>d.id===dd.id))
        this.markedSegments && cells.classed('marked',(dd)=>this.markedSegments.length>0 && this.markedSegments.find((d)=>d===dd.id))
        // cells.select('path').attr('filter',(dd)=>self.selection.find((d)=>d.id===dd.id)?'url(#shadow)':'')
      }
      let updateTooltip = () => {
        if(!this.showTooltip) return
        let container = d3.select(this.$refs.tooltipContainer)
        let tooltip = container.select('.tooltip')
        let offset = this.$refs.svg.getBoundingClientRect()
        let gbox = this.$refs.svg.children[0].getBoundingClientRect()
        if(self.highlighted && self.highlighted.value){
          cells.each(function (d) {
            if(d===self.highlighted){
              let text = d3.select(this).select('text')
              let bbox = text.node().getBoundingClientRect()
              // let mtx =  text.node().getCTM();
              // let point = self.$refs.svg.createSVGPoint()
              // point.x = bbox.width/2
              // let newpos = bbox
              tooltip
                .style('left',( - offset.x + bbox.x + bbox.width/2) +'px')
                .style('top',( - offset.y + bbox.y - bbox.height/2 )+'px')
              if(d.tooltipData) {
                let tooltipDatas = Array.isArray(d.tooltipData)?d.tooltipData:[d.tooltipData]
                let str = tooltipDatas.map((td)=>{
                  if(td.title) {
                    return `<div class="tooltip-datum">
                      <div class="title">
                        <div class="dot" style="background-color: ${td.color || d.tooltipColor}"></div>
                        <div class="text">${td.mainTitle}</div>
                      </div>
                      <div class="value">${td.title}: ${td.value}</div>
                    </div>`
                  }
                  else return `<div class="tooltip-datum">${td}</div>`
                }).join('')
                tooltip.select('.text').html(str)
              }
              else tooltip.select('.text').text(d.value)
            }
          })
          container.style('display','inherit')
        } else {
          container.style('display','none')
        }
      }
      updateTooltip()
      // cells.select('text').attr('dx','-.2em')
      cells.on('mouseout',(d)=>{
        if(self.highlighted.id===d.id) self.highlighted = null
        self.$emit('highlight',self.highlighted)
        updateClasses()
        updateTooltip()
      })
      cells.on('mouseover',(d)=>{
        self.highlighted = d
        self.$emit('highlight',self.highlighted)
        updateClasses()
        updateTooltip()
      })
      if(this.selectable){
        cells.on('click', (d)=>{
          let currentSel = self.selection || []
          let newSel
          if(self.multiSelection){
            newSel = currentSel.find((dd)=>dd.id===d.id)?currentSel.filter((dd)=>dd.id!==d.id):[...currentSel,d]
          } else {
            newSel = currentSel.find((dd)=>dd.id===d.id)?[]:[d]
          }
          self.triggerChagne(newSel)
        })
        
      }
      let getPropperFill = (color) => {
        // color = ['#7c44ca','#00ddee','#0000ff']
        if(Array.isArray(color)){
          let patternId = 'pattern'+color.map((d)=>Object.values(d3.color(d).rgb()).join('_')).join('_')
          let defs = d3.select(this.$refs.svg).selectAll('defs').data([null])
          defs = defs.merge(defs.enter().append('defs'))
          let pattern = defs.selectAll(`#${patternId}`).data([patternId])
          let newPattern = pattern.enter().append('pattern')
            .attr('id',patternId)
            .attr('width','100%')
            .attr('height','100%')
            .attr('patternTransform','skewX(-45)')
            .attr('patternContentUnits','userSpaceOnUse')
          let nBands = color.length * 4
          let bandWidth = (1/nBands * 200)
          color.forEach((c,i)=>{
            newPattern.append('rect').attr('fill',c).attr('x', i*(bandWidth)+ 'px').attr('y','0').attr('width', bandWidth + 'px' ).attr('height','200px')
            newPattern.append('rect').attr('fill',c).attr('x',((i + (color.length))*(bandWidth))+ 'px').attr('y','0').attr('width',bandWidth + 'px').attr('height','200px')
            newPattern.append('rect').attr('fill',c).attr('x',((i + 2*(color.length))*(bandWidth))+ 'px').attr('y','0').attr('width',bandWidth+ 'px').attr('height','200px')
            newPattern.append('rect').attr('fill',c).attr('x',((i + 3*(color.length))*(bandWidth))+ 'px').attr('y','0').attr('width',bandWidth+ 'px').attr('height','200px')
            newPattern.append('rect').attr('fill',c).attr('x',((i + 4*(color.length))*(bandWidth))+ 'px').attr('y','0').attr('width',bandWidth+ 'px').attr('height','200px')
          })
          // newPattern.append('circle').attr('fill','#0fa').attr('cx','5').attr('cy','5').attr('r','10')
          // pattern = pattern.merge(newPattern)
          
          return `url(#${patternId})`
        } else {
          return color
        }
      }
      if(!this.instantUpdate) {
        cells.transition().attr('fill',(d,i)=>{
          return getPropperFill(d.color || this.defaultColor || '#fff')
        })
      } else {
        cells.attr('fill',(d,i)=>{
          return getPropperFill(d.color || this.defaultColor || '#fff')
        })
      }
      
      updateClasses()
      
      let tooltipContainer = d3.select(this.$refs.tooltipContainer)
      let tooltip = tooltipContainer.selectAll('.tooltip').data([null])
      let tooltipEnter = tooltip.enter().append('div').attr('class','tooltip down')
      tooltipEnter.append('div').attr('class','text')
      tooltip = tooltip.merge(tooltipEnter)
      
      
    }
  },
  watch: {
    _genericData (){
      this.update()
    },
    selection () {
      this.update()
    },
    availableSegments (){
      this.update()
    }
  },
  computed:{
    _width () {
      return this.width || this.size.width
    },
    _height () {
      return this.height || this.size.height
    },
    _colorScale () {
      return (index) => {
        let prop = this.colorScale || this.colorScales[index]
        return prop //.domain([0,1])
      }
    },
    _genericData () {
      let result
      if(this.data){
        result = this.data.map((d)=>{
          // let ids = d.id?(Array.isArray(d.id)?d.id:[d.id]):[]
          // return ids.map((id)=>{
          //   return {
          //     ...d,
          //     id: id,
          //     color: this._colorScale()(d.value)
          //   }
          // })
          return {
            ...d,
            color: this._colorScale()(isNaN(+d.value)?this._colorScale().domain()[1]:+d.value),
            tooltipColor: this._colorScale()(this._colorScale().domain()[1])
          }
        }).flat()
      } else if(this.datas){
        result = this.datas.map((data,i)=>{
          let subdata = data.data || data
          // return subdata.map((d)=>{
          //   let ids = d.id?(Array.isArray(d.id)?d.id:[d.id]):[]
          //   return ids.map((id)=>{
          //     return {
          //       ...d,
          //       id: id,
          //       color: this._colorScale(i)(d.value)
          //     }
          //   })
          // }).flat()
          return subdata.flat().map((d)=>{
            return {
              ...d,
              color: this._colorScale(i)(isNaN(+d.value)?this._colorScale(i).domain()[1]:+d.value),
              tooltipColor: this._colorScale(i)(this._colorScale(i).domain()[1])
            }
          })
        }).flat()
        
        // HABRIA QEU MERGEAR LSO QEU TENGAN EL MISMO ID!!!!!
        let dict = {}
        result.forEach((d)=>{
          if(!dict[d.id]) dict[d.id] = []
          dict[d.id].push(d)
        })
        result = Object.keys(dict).map((k)=>{
          if(dict[k].length===1) return dict[k][0]
          else {
            let val = {...dict[k][0],color:dict[k].map((dd)=>dd.color)}
            val.tooltipData = dict[k].map((d)=>({...d.tooltipData,color:d.tooltipColor}))
            return val
          }
        })
        
      } else {
        result = []
      }
      return result
    }
  }
}
</script>

<style scoped lang="stylus">
.bullseye-diagram
  position: relative
  svg
    user-select none
    position absolute
    width 100%
    height 100%
    .cell
      transition opacity .3s
      cursor pointer
      stroke rgba(0,0,0,0.2)
      background-repeat: repeat;

      .crosshair &
        cursor crosshair
      text
        fill #000
        font-size 20px
      &.marked
        path 
          stroke rgba($radical-red, 0.5)
          stroke-width 4px
        text
          font-weight bold
      &.highlighted
        opacity 1
        path
          stroke rgba(0,0,0,0.8)
          stroke-width 5px
      // &.unhighlighted
      //   opacity 0.5
      &.selected
        font-weight bold
        opacity 1
        path
          stroke rgba(0,0,0,0.8)
          stroke-width 5px
      // &.unselected
      //   opacity 0.2
      &.disabled
        opacity 0.2
        pointer-events none
      
  .btn
    position absolute
    top 0
      
  .tooltip-container
    position absolute
    top 0
    left 0
    z-index 1000
    >>> .tooltip
      position absolute
      transform: translate(-50%,30px);
     
      background #fff
      border-radius 4px
      box-shadow 0 0 5px rgba(0,0,0,0.2)
      pointer-events none
      m-tooltip-tip()
      white-space nowrap
      .tooltip-datum
        padding 5px
        display flex
        flex-direction column
        &:not(:last-child)
          margin-bottom 2px
          padding-bottom 5px
          border-bottom solid 1px $heather
        .title
          m-font-size(16, 18)
          color: $cloud-burst
          font-weight: $fw-medium
          display flex
          align-items center
          margin-bottom 4px
          padding-bottom 5px
          border-bottom 1px solid $mystic
          .dot
            width 8px
            height 8px
            flex 0 0 8px
            border-radius 8px
            margin-right 4px
        .value
          margin-bottom 5px
          m-font-size(16, 18)
          color: $gull-gray
  .marked-legend
    position absolute
    bottom -10px
    right 0px
    m-font-size(10, 12)
    .mark
      m-font-size(12, 12)
      color rgba($radical-red, 0.5)
      font-weight bold
</style>